import Index from './index.vue'
import List from './components/List.vue'

export default [
  {
    path: 'reconcile',
    name: 'reconcile',
    component: Index,
    title: 'Reconcile',
    redirect: { name: 'reconcile-list' },
    children: [
      {
        path: 'list',
        name: 'reconcile-list',
        component: List,
      },
    ],
  },
]
